<template lang="pug">
div
    div.row
        div.col-xs-9
            small.pull-right Subtotal
        div.col-xs-3
            small.pull-right {{ returnSubTotal }}

    //- rounding
    div.row(v-if="paymentName.includes('cash')")
        div.col-xs-9
            small.pull-right Rounding
        div.col-xs-3
            small.pull-right {{ returnRounding }}

    //- grand total
    div.row.text-md
        div.col-xs-9
            small.pull-right Grand Total
        div.col-xs-3
            small.pull-right {{ returnGrandTotal }}

    //- payments
    div.row(v-for="payment in payments")
        .col-xs-12(v-if="payment.card")
            .row
                .col-xs-9.text-muted
                    small.pull-right {{ getTerminalName(payment) }}
            .row
                .col-xs-9
                    small.pull-right(v-if="payment.reference_number == null") {{ payment.card.name }}
                    small.pull-right(v-else) {{ payment.card.name }} ({{ payment.reference_number }})
                .col-xs-3
                    small.pull-right {{ payment.amount }}

        div(v-if="!payment.card")
            .col-xs-9
                small.pull-right(v-if="payment.reference_number == null") {{ payment.name }}
                small.pull-right(v-else) {{ payment.name }} ({{ payment.reference_number }})
            .col-xs-3
                small.pull-right {{ returnGrandTotal }}

    //- change
    div.row(v-if="paymentName.includes('cash')")
        div.col-xs-9
            small.pull-right Change
        div.col-xs-3
            small.pull-right 0.00

    div.row(v-if="orderProducts.length")
        div.col-xs-12
            hr

    div.row
        div.col-xs-8
            small Net Sales Purchased - Returned

        div.col-xs-4
            small.pull-right {{ calculateGrandTotal }}
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'discounts',
            'totalDiscount',
            'totalAfterDiscount',
            'charges',
            'taxes',
            'totalChange',
            'payments',
            'fuel',
            'paymentName',
            'returnSubTotal',
            'returnGrandTotal',
            'returnRounding',
            'grandTotal',
            'orderProducts',
        ]),

        hasDiscount() {
            return this.discounts.length > 0;
        },

        calculateGrandTotal() {
            let total = this.grandTotal - this.returnGrandTotal;

            return total.toFixed(2);
        },
    },

    methods: {
        getTerminalName(payment) {
            if (this.fuel) {
                let tid = this.fuel.terminal_id;
                let tty = this.fuel.terminal_type;

                if (tid && tty) {
                    return `${tty} (${tid})`;
                }
            }

            return payment.name;
        },
    },
};
</script>
